<template>
  <div>
    <div v-if="source != null" class="flex text-sm pr-4">
      <div>
        <router-link :to="'/chats/' + source.supportChat">
          {{ getFullname(source) }}
        </router-link>
      </div>

      <div class="ml-auto">
        <p class="m-0">{{ source.phone }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getFullname } from '@/utils/name'

export default {
  props: {
    index: {
      type: Number
    },
    source: {
      type: Object
    }
  },
  methods: {
    getFullname
  }
}
</script>
